//obviously, not meant to be here, should be in richmedia
$('body').on('click', '.ad-TransitionClose', function (e) {
    e.preventDefault();
    console.log('AD CLOSED');
    $('.ad-Curtain').hide();
});


//import {statusRowContentFuture} from "./templates/status-row-content-future.js";
import {statusRowContentLive} from "./templates/status-row-content-live.js";
import {statusRowContentFinished} from "./templates/status-row-content-finished.js";
import {lastVideoTemplate} from "./templates/last-video.js";


export function updateLivescoreUI(UpdatedMatchesObj) {
    
    let dataLength = Object.keys(UpdatedMatchesObj).length;
    //console.log('UpdatedMatchesObj length: ', dataLength);    
    let hostScoreSelector = '';
    let guestScoreSelector = '';
    let statusSelector = '';    
    
    for (let i = 0; i < dataLength; i++){
        let matchId = Object.keys(UpdatedMatchesObj)[i];
        
        if (Object.keys(UpdatedMatchesObj[matchId]).length === 0) continue;

        let identificationSelector = '';
        if ($('.site-wrapper').hasClass('livescore')){
            identificationSelector = '#match-' + matchId;
        } else {
            identificationSelector = '[data-id = "' + matchId + '"]';        
        }

        hostScoreSelector = identificationSelector + ' .host-score';
        guestScoreSelector = identificationSelector + ' .guest-score';
        statusSelector = identificationSelector + ' .status';

        if ( UpdatedMatchesObj[matchId].team_1 != null || UpdatedMatchesObj[matchId].team_2 != null ){
            updateScoreHtml(hostScoreSelector, guestScoreSelector, UpdatedMatchesObj[matchId].team_1, UpdatedMatchesObj[matchId].team_2);
        }
        
        if ( UpdatedMatchesObj[matchId].status != null ){
            if (UpdatedMatchesObj[matchId].added_time != null){
                changeStatus(identificationSelector, statusSelector, UpdatedMatchesObj[matchId].status, UpdatedMatchesObj[matchId].added_time);
            } else {
                changeStatus(identificationSelector, statusSelector, UpdatedMatchesObj[matchId].status);                
            }
        }
        
        if ( UpdatedMatchesObj[matchId].status == null ){
            if (UpdatedMatchesObj[matchId].added_time != null){
                changeStatus(identificationSelector, statusSelector, 
                            $(statusSelector).html().split('+')[0].trim(), 
                            UpdatedMatchesObj[matchId].added_time);
            }
        }
        
        if ( UpdatedMatchesObj[matchId].thumb != null ){
            if( $('.carousel-slider.livescore').length > 0 ){
                let currentUrl = $(identificationSelector).find('a.match-info').attr('href');
                updateVideo(identificationSelector, UpdatedMatchesObj[matchId].thumb, currentUrl);                
            } 
        }
    
    }
}

function updateScoreHtml(hostScoreSelector, guestScoreSelector, hostScore, guestScore){
    console.log('hostScoreSelector, guestScoreSelector, hostScore, guestScore', hostScoreSelector, guestScoreSelector, hostScore, guestScore);
    hostScore != null && $(hostScoreSelector).html(hostScore);
    guestScore != null && $(guestScoreSelector).html(guestScore);
}

function changeStatus(identificationSelector, statusSelector, status, addedTime = ''){
    console.log('status', status);
    
    let statusIsMinutes = /\d/.test( status );
    
    if ((status == 'HT') || (status == 'HET') || (status == 'PEN') || (status == 'PP') || (status == 'ET') || statusIsMinutes) {
                
        if( $('.carousel-slider.livescore').length > 0 && !$(identificationSelector).find('.match-info').hasClass('live') && $(identificationSelector).find('.match-info').hasClass('future') ){
            //console.log('carousel change status');
            $(identificationSelector).find('.status-row').html(statusRowContentLive( 0 , 0, status, false));
        }
        
        $(identificationSelector).find('.match-info').removeClass('future').addClass('live');
        $(statusSelector).removeClass('future').addClass('live');
        
        if (statusIsMinutes) {
            $(statusSelector).length > 0 && $(statusSelector).html(status + '\'');
        } else {
            $(statusSelector).length > 0 && $(statusSelector).html(status);
        }
        
    } else {
        $(identificationSelector).find('.match-info').removeClass('live');
        $(statusSelector).removeClass('live');
        if (status == 'FT'){
            $(statusSelector).removeClass('minute').addClass('label minor-info').html('приключил');
//            $(statusSelector).siblings('.live-label').hide();
        }
    }  
     
    if (addedTime != ''){
        $(statusSelector).length > 0 && $(statusSelector).html(status + '+' + addedTime + '\'');
    }
    
}

function updateVideo(identificationSelector, thumb, link){
    if ($(identificationSelector).find('.last-video').legth > 0) {
        $('.last-video img').attr('src', thumb);
    } else {
        $(identificationSelector).append(lastVideoTemplate(thumb, link));
    }
}

function Odds(coef_home, coef_away, coef_x) {
//    if ((typeof coef_home != "undefined") && (typeof coef_away != "undefined") && (typeof coef_x != "undefined")) {
//        if (this.baseData.coef_home != coef_home) {
//            this.baseData.coef_home = coef_home;
//        }
//        if (this.baseData.coef_away != coef_away) {
//            this.baseData.coef_away = coef_away;
//        }
//        if (this.baseData.coef_x != coef_x) {
//            this.baseData.coef_x = coef_x;
//        }
//        this.updateCoefficient();
//    }
}
